
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 188 188"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke-width":"6","fill":"none"}},[_c('path',{attrs:{"stroke-linejoin":"round","d":"M94 19l90 48.317H4z"}}),_c('path',{attrs:{"d":"M7.14 152.396h173.721V165H7.14zm76.395-85.079h20.93v10.504h-20.93zm0 74.575h20.93v10.504h-20.93z"}}),_c('path',{attrs:{"d":"M88.767 77.82h10.465v64.072H88.767zM51.093 96.727c0-4.64 3.748-8.403 8.372-8.403s8.372 3.762 8.372 8.403v35.712H51.093V96.727zm69.07 0c0-4.64 3.748-8.403 8.372-8.403 4.623 0 8.372 3.762 8.372 8.403v35.712h-16.744V96.727zm32.442-29.41h20.93v10.504h-20.93zm0 74.575h20.93v10.504h-20.93z"}}),_c('path',{attrs:{"d":"M157.837 77.82h10.465v64.072h-10.465zM14.465 67.317h20.93v10.504h-20.93zm0 74.575h20.93v10.504h-20.93z"}}),_c('path',{attrs:{"d":"M19.698 77.82h10.465v64.072H19.698z"}})])])
          )
        }
      }
    